// One file field for every upload form (Fase 4 of
// docs/plans/2026-11-02-audit-ui-ux.md): the label, Pilih file (Pilih file
// lain once one is chosen), the chosen name and size, and one hint line that
// turns into the error. Used by Review Dokumen and Data Perusahaan; the file
// stays in the form until it is sent.
import type { ChangeEvent, RefObject } from "react";
import { formatFileSize } from "../project/files";
import { Glyph } from "./icons";

export interface FilePickFieldProps {
  /** Prefix for the label id (`${id}-pick-label`). */
  id: string;
  label?: string;
  required?: boolean;
  accept: string;
  file: File | null;
  onPick: (e: ChangeEvent<HTMLInputElement>) => void;
  /** The hidden input, so the form can clear it after sending. */
  inputRef: RefObject<HTMLInputElement | null>;
  disabled?: boolean;
  error?: string | null;
  /** What may be picked (formats, size), shown while there is no error. */
  hint: string;
}

export function FilePickField({ id, label = "File", required, accept, file, onPick, inputRef, disabled, error, hint }: FilePickFieldProps) {
  const labelId = `${id}-pick-label`;
  return (
    <div className="field">
      <span className="field-label" id={labelId}>
        {label}
        {required ? (
          <span className="req" aria-hidden="true">
            {" "}
            *
          </span>
        ) : null}
      </span>
      <div className="button-row">
        <input ref={inputRef} type="file" accept={accept} hidden onChange={onPick} aria-labelledby={labelId} />
        <button type="button" className="btn btn-secondary" onClick={() => inputRef.current?.click()} disabled={disabled}>
          <Glyph name="paperclip" />
          <span>{file ? "Pilih file lain" : "Pilih file"}</span>
        </button>
        <span className="form-note file-pick-name" aria-live="polite">
          {file ? `${file.name}, ${formatFileSize(file.size)}` : "Belum ada file dipilih"}
        </span>
      </div>
      <p className="field-hint" data-state={error ? "error" : undefined} aria-live="polite">
        {error ? (
          <>
            <Glyph name="danger" size={16} />
            <span>{error}</span>
          </>
        ) : (
          hint
        )}
      </p>
    </div>
  );
}
